import { contrastColour } from '../utils/helpers';
import type { Tag } from '../types';

interface Props {
  tag: Tag;
  small?: boolean;
  onRemove?: () => void;
}

export default function TagPill({ tag, small, onRemove }: Props) {
  const text = contrastColour(tag.colour);
  return (
    <span
      className={`inline-flex items-center gap-1 font-body pill ${small ? 'text-[9px] px-1 py-0' : 'text-[10px] px-1.5 py-0.5'}`}
      style={{ background: tag.colour, color: text }}
    >
      {tag.name}
      {onRemove && (
        <button
          onClick={(e) => { e.stopPropagation(); onRemove(); }}
          className="ml-0.5 opacity-70 hover:opacity-100 leading-none"
        >
          ×
        </button>
      )}
    </span>
  );
}
